import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? "http://127.0.0.1:8000";

// Cache token at module-load time so the interceptor has it immediately on first request
let _token = null;
try { _token = localStorage.getItem("deepend.jwt") || null; } catch (_e) {}

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = _token || localStorage.getItem("deepend.jwt");
  if (token) {
    // Use AxiosHeaders.set() — bracket assignment does not serialize in axios 1.x
    config.headers.set("Authorization", `Bearer ${token}`);
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      _token = null;
      try {
        localStorage.removeItem("deepend.jwt");
        localStorage.removeItem("deepend.user");
      } catch (_e) {}
      window.location.replace("/login?expired=1");
    }
    return Promise.reject(error);
  }
);

export function setAuthToken(token) {
  _token = token || null;
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
}
